module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/RutasSugeridas/RutasSugeridasParent.component.html
// module id = ../../../../../src/app/views/RutasSugeridas/RutasSugeridasParent.component.html
// module chunks = main